import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Leaf, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#FFF8E7] via-[#FFFEF7] to-[#F0FFF4]">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-[#FFB830]/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-[#7CB342]/10 rounded-full blur-3xl animate-pulse delay-1000" />
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-[#FFA500]/10 rounded-full blur-2xl animate-pulse delay-500" />

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-center md:text-left space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-[#7CB342]/20">
                <Leaf className="text-[#7CB342]" size={20} />
                <span className="text-sm font-medium text-gray-700">100% Natural y Fresco</span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-tight">
                <span className="text-[#FFB830]">La Piña</span>
                <br />
                <span className="text-[#7CB342]">Sabor que</span>
                <br />
                <span className="text-gray-800">Provoca</span>
              </h1>

              <p className="text-lg md:text-xl text-gray-600 max-w-lg mx-auto md:mx-0">
                Jugos naturales, batidos deliciosos y comida fresca preparada con amor. 
                ¡Ven y descubre el verdadero sabor tropical!
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <Button
                  onClick={() => scrollToSection('menu')}
                  className="bg-[#FFB830] hover:bg-[#FFA500] text-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  Ver Menú
                  <ArrowRight className="ml-2" size={20} />
                </Button>
                <Button
                  onClick={() => scrollToSection('reservas')}
                  variant="outline"
                  className="border-2 border-[#7CB342] text-[#7CB342] hover:bg-[#7CB342] hover:text-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-300 hover:scale-105"
                >
                  Hacer Reserva
                </Button>
              </div>

              {/* Quick Stats */}
              <div className="grid grid-cols-3 gap-4 pt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FFB830]">100%</div>
                  <div className="text-sm text-gray-600">Natural</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#7CB342]">50+</div>
                  <div className="text-sm text-gray-600">Productos</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FFA500]">5★</div>
                  <div className="text-sm text-gray-600">Calificación</div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              <div className="relative w-full max-w-md">
                {/* Animated background circle */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#FFB830]/20 to-[#7CB342]/20 rounded-full blur-2xl animate-pulse" />
                
                {/* Logo Image */}
                <div className="relative z-10 bg-white/40 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-white/50">
                  <img
                    src="https://customer-assets.emergentagent.com/job_pinata-toys/artifacts/8n9pisyg_Gemini_Generated_Image_hfisr7hfisr7hfis.png"
                    alt="La Piña Logo"
                    className="w-full h-auto animate-float"
                  />
                </div>

                {/* Floating icons */}
                <div className="absolute -top-4 -right-4 bg-white rounded-full p-3 shadow-lg animate-bounce">
                  <Sparkles className="text-[#FFB830]" size={24} />
                </div>
                <div className="absolute -bottom-4 -left-4 bg-white rounded-full p-3 shadow-lg animate-bounce delay-500">
                  <Leaf className="text-[#7CB342]" size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave separator */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
          <path
            fill="#ffffff"
            fillOpacity="1"
            d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
